/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Button, createStyles, Theme } from "@material-ui/core";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import * as React from "react";

import CalculatorIcon from "../Icons/CalculatorIcon";

type CalculatorButtonProps = WithStyles<typeof styles> & {
    onClick();
};

const CalculatorButton: React.SFC<CalculatorButtonProps> = ({ classes, theme, onClick }) => {
    return (
        <Button className={classes.calculator} onClick={onClick}>
            <CalculatorIcon nativeColor={theme.palette.primary.main} />
            <span className={classes.buttonLabel}>Tarificateur</span>
        </Button>
    );
};

export const styles = ({ spacing, palette }: Theme) =>
    createStyles({
        calculator: {
            marginTop: spacing.unit * 5,
            backgroundColor: palette.secondary.main,
            width: "100%",
            padding: spacing.unit * 2,
            borderRadius: 0,
            "&:hover": {
                backgroundColor: palette.secondary.main,
            },
        },
        buttonLabel: {
            marginLeft: spacing.unit,
            fontWeight: 600,
            textTransform: "lowercase",
            "&:first-letter": {
                textTransform: "capitalize",
            },
        },
    });

export default withStyles(styles, { withTheme: true })(CalculatorButton);



// WEBPACK FOOTER //
// ./src/components/Calculator/CalculatorButton.tsx